import { CartridgeIcon, DropIcon } from "@rothoblaas/design-system";
import { FC, memo } from "react";
import useI18n from "../../../hooks/useTranslations";
import { ConcreteResinCalculation } from "../../../http/concreteResin/types/calculations";
import { getNumberFormat } from "../../../utils/numberFormat";
import styles from "./ConcreteResinSummary.module.css";

type Props = {
  /** The calculation's results, the server's */
  data: ConcreteResinCalculation | null;
};

const ConcreteResinSummary: FC<Props> = ({ data }) => {
  const i18n = useI18n();
  const resinTranslation = i18n.translation.concreteResinModule;
  const liters = data?.estimatedLiters;
  const cartridges = data?.estimatedCartridges;
  const cartridgeVolume = data?.cartridgeVolumeMl;

  return (
    <div className={styles.internalWrapper}>
      {/* Total Volume */}
      <div className={styles.section}>
        <div className={styles.iconCircle}>
          <DropIcon className={styles.icon} />
        </div>
        <span className={styles.label}>{resinTranslation.totalVolumeRequired.toUpperCase()}</span>
        <span className={styles.bigNumber}>
          {liters
            ? getNumberFormat(i18n.translation.languageCode, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(liters)
            : "--"}
        </span>
        <span className={styles.subText}>{resinTranslation.liters.toUpperCase()}</span>
      </div>

      <hr className={styles.divider} />

      {/* Cartridges: to order, by the anchor's order multiple */}
      <div className={styles.section}>
        <div className={styles.iconCircle}>
          <CartridgeIcon className={styles.icon} />
        </div>
        <span className={styles.label}>{resinTranslation.cartridges.toUpperCase()}</span>
        <span className={styles.bigNumber}>{cartridges ?? "--"}</span>
        <span className={styles.subText}>
          {cartridgeVolume != null ? `${data?.cartridgeLabel} ${cartridgeVolume} ml` : `--`}
        </span>
      </div>
    </div>
  );
};

export default memo(ConcreteResinSummary);
